export interface Identifiable {
  readonly id: number;
  readonly uuid: string;
}

export class BasicEntity implements Identifiable {

  id: number;
  uuid: string;
}
